import { render, staticRenderFns } from "./ComTable.vue?vue&type=template&id=a9df4c80&scoped=true&"
import script from "./ComTable.vue?vue&type=script&lang=js&"
export * from "./ComTable.vue?vue&type=script&lang=js&"
import style0 from "./ComTable.vue?vue&type=style&index=0&id=a9df4c80&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9df4c80",
  null
  
)

export default component.exports